import { userService } from '@/helpers/authservice/user.service';
import EmployeeAPI from '@/services/employee/employeeAPI';
import CompanyAPI from '@/services/company/companyAPI';
import CompanySSOAPI from '@/services/sso/company/companySSO.API';
import UserAPI from '@/services/user/userAPI';
import Swal from "sweetalert2";

const user = JSON.parse(localStorage.getItem('user')) || {};
const info = JSON.parse(localStorage.getItem('info')) || {};

export const state = user
  ? { status: { loggeduser: true }, user, info }
  : { status: {}, user: null, info: null }

export const getters = {
  loggedIn(state) {
    return !!(state.user && state.user.token)
  },
  getUser: state => {
    return {
      ...state.user,
      ...state.info,
    }
  },
}

export const actions = {
  // Logs in the user.
  // eslint-disable-next-line no-unused-vars
  login({ dispatch, commit }, { email, password }) {
    commit('loginRequest', { email });

    // Ejecutar servicio de login
    userService.login(email, password)
      .then(user => {

        try {

          // Obtener datos de usuario y, sus roles y permisos asociados
          let userData = JSON.parse(localStorage.getItem('user'))
          let infoData = JSON.parse(localStorage.getItem('info'))

          // Obtener su rol del SSO
          const resp = userData.nodexum.roles.find(role =>
            role.name === 'root' || role.name === 'admin' || role.name === "company" || role.name === "user") || null

          // Obtener las compañías asociadas al usuario del SSO
          const companies = userData.nodexum.companies || []

          // Mensaje de datos recuperados
          console.group('Login Success')
          console.log('This is the saved data from local user: ', userData)
          console.log('This is the response from the roles: ', resp)
          console.groupEnd()

          // Crear JSON para administrar roles y permisos
          let newInfo = {
            sstID: null,
            role: null,
            permissions: [
              {
                id: 1,
                name: 'Consultar'
              },
              {
                id: 2,
                name: 'Crear'
              },
              {
                id: 3,
                name: 'Editar'
              },
              {
                id: 4,
                name: 'Eliminar'
              },
              {
                id: 5,
                name: 'Actualizar items'
              },
              {
                id: 6,
                name: 'Asignar responsable de implemenación'
              }
            ]
          }

          // Asignar id de SSO al usuario en el SST (Requerido para algunos ítems)
          EmployeeAPI.setSSOIDbyEmail(email, userData.nodexum.id)
            .then(response => {
            })
            .catch(error => {
            })

          // Obtener compañía en el SST por campo UUID
          CompanyAPI.getCompanyByUUID(userData.nodexum.id)
            .then(response => {

              // Si el usuario posee rol de root, admin o company desde el SSO
              if (resp) {

                // Si el usuario es root en el SSO
                if (resp.name === 'root') {

                  // Dar rol y permisos para el SST
                  newInfo.role = 1
                  newInfo.sstID = 0
                  localStorage.setItem('info', JSON.stringify(newInfo))

                  // Redirigir al dashboard
                  window.location.href = '/'

                } // Cierre de if: Si el usuario es root en el SSO

                // Si el usuario NO es root en el SSO
                else {

                  // Obtener datos de usuario en el SST
                  UserAPI.getSSO(userData.nodexum.id)
                    .then(res => {

                      // Si el usuario existe en el SST
                      if (res.length > 0) {

                        const sst = res[0]

                        // Settear rol y permisos desde el SST (fuente de verdad).
                        // No se sobreescribe con el rol del SSO para no pisar los
                        // roles definidos en RolSeeder (Cliente Admin, Talento Humano,
                        // Responsable Operativo, etc.).
                        newInfo.role = sst.rol.id
                        newInfo.sstID = sst.id
                        newInfo.permissions = sst.permissions

                        commit('loginSuccess', user, newInfo);
                        localStorage.setItem('info', JSON.stringify(newInfo))

                        // Roles internos y roles asignados (multi-empresa via SST) van
                        // directo al dashboard. Para Cliente Admin / Talento Humano /
                        // Responsable Operativo (6/7/8) la empresa primaria no aplica:
                        // eligen una desde el modal de selecciOn de empresa.
                        if ([1, 2, 3, 6, 7, 8].includes(newInfo.role)) {
                          window.location.href = '/'
                        }
                        // Roles asociados a una empresa unica (Compania, Empleado): validar
                        // que la empresa exista en SST.
                        else {

                          // Si la compañía existe en el SST
                          if (response.length > 0) {
                            window.location.href = '/'
                          }
                          // Si la compañía NO existe en el SST
                          else {

                            console.log('company not found')

                            if (companies.length > 0) {
                              CompanySSOAPI.getCompany(companies[0].id)
                                .then(() => {
                                  window.location.href = `/forms/editar-empresa/${companies[0].id}`
                                })
                                .catch(error => {
                                  console.log(error)
                                  localStorage.removeItem('user')
                                  localStorage.removeItem('info')
                                })
                            } else {
                              Swal.fire({
                                title: "Debes esperar a que un usuario administrador te habilite para poder acceder al sistema",
                                type: "warning",
                                confirmButtonClass: "btn btn-confirm mt-2",
                              });
                              localStorage.removeItem('user')
                              localStorage.removeItem('info')
                            }

                          } // Cierre de else: Si la compañía NO existe en el SST

                        } // Cierre de else: Roles asociados a empresa

                      } // Cierre de if: Si el usuario existe en el SST

                      // Si el usuario NO existe en el SST
                      else {

                        // Dar rol y permisos para el SST
                        newInfo.role = 4

                        // Settear los permisos idóneos                
                        newInfo.permissions = [
                          {
                            id: 1,
                            name: 'Consultar'
                          },
                          {
                            id: 2,
                            name: 'Crear'
                          },
                          {
                            id: 3,
                            name: 'Editar'
                          },
                          {
                            id: 4,
                            name: 'Eliminar'
                          },
                          {
                            id: 6,
                            name: 'Asignar responsable de implemenación'
                          }
                        ]

                        // SI la compañía existe en el SST
                        if (response.length > 0) {

                          // Redirigir al dashboard
                          console.log('company found')
                          commit('loginSuccess', user, newInfo);
                          localStorage.setItem('info', JSON.stringify(newInfo))
                          window.location.href = '/'

                        } // Cierre de if: SI la compañía existe en el SST

                        // SI la compañía NO existe en el SST
                        else {

                          console.log('company not found')

                          /// SI existen compañías asociadas al usuario en el SSO
                          if (companies.length > 0) {

                            // Obtener los datos de la primera compañía asociada al usuario en el SSO
                            CompanySSOAPI.getCompany(companies[0].id)
                              .then(response => {

                                // Redirigir al formulario de reigstro de compañía
                                commit('loginSuccess', user, newInfo);
                                localStorage.setItem('info', JSON.stringify(newInfo))
                                window.location.href = `/forms/editar-empresa/${companies[0].id}`

                              })
                              .catch(error => {
                                console.log(error)
                                localStorage.removeItem('user')
                                localStorage.removeItem('info')
                              })

                          } // Cierre de if: SI existen compañías asociadas al usuario en el SSO

                          // SI NO existen compañías asociadas al usuario en el SSO
                          else {
                            Swal.fire({
                              title: "Debes esperar a que un usuario le asocie a una compañía para poder acceder al sistema",
                              type: "warning",
                              confirmButtonClass: "btn btn-confirm mt-2",
                            });
                            localStorage.removeItem('user')
                            localStorage.removeItem('info')
                          } // Cierre de else: SI NO existen compañías asociadas al usuario en el SSO

                        } // Cierre de else: SI la compañía NO existe en el SST

                      } // Cierre de else: Si el usuario NO existe en el SST

                    })
                    .catch(err => {
                      console.log(err)
                      localStorage.removeItem('user')
                      localStorage.removeItem('info')
                    })

                } // Cierre de else: Si el usuario NO es root en el SSO

              } // Cierre de if: Si el usuario existe en el SSO

              // Si el usuario NO existe en el SSO
              else {
                Swal.fire({
                  title: "Es necesario que tengas un usuario registrado para acceder al sistema",
                  type: "warning",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });

                localStorage.removeItem('user')
                localStorage.removeItem('info')
              } // Cierre de else: Si el usuario NO existe en el SSO

            })
            .catch(error => {
              console.log(error)
              localStorage.removeItem('user')
              localStorage.removeItem('info')
            })

        } catch (error) {
          console.log(error)

          localStorage.removeItem('user')
          localStorage.removeItem('info')
        }

      },
        error => {
          commit('loginFailure', error);
          dispatch('notification/error', error, { root: true });
        }
      );
  },

  // Validates the current session token
  validate({ state }) {
    if (!state.user || !state.user.token) return Promise.resolve(null)
    return Promise.resolve(state.user)
  },

  // Logout the user
  logout({ commit }) {
    userService.logout();
    commit('logout');
  },

};

export const mutations = {
  loginRequest(state, user) {
    state.status = { loggingIn: true };
    state.user = user;
  },
  loginSuccess(state, user, info) {
    state.status = { loggeduser: true };
    state.user = user;
    state.info = info;
  },
  loginFailure(state) {
    state.status = {};
    state.user = null;
    state.info = null
  },
  logout(state) {
    state.status = {};
    state.user = null;
    state.info = null
  },
};

